import api from "./api.js"

export const getUser = async (userId) => {
  const response = api.get(`/user-authenticate/${userId}`)
  return response
}

export const fnGetUsers = async () => {
  const response = api.get(`/operational-panel-users`)
  return response
}

export const fnGetUsersAndTeams = async () => {
  const response = await api.get(`/operational-panel-users-and-teams`);
  return response.data;
};


export async function logout() {
  const response = await api.get("/logout")
  return response
}

export async function fnGetStatusLogin() {
  const response = await api.get("/status/login")
  return response
}

export async function fnChangeCostumer(cust_id) {
  const response = await api.get(`/customer/connect/${cust_id}`)
  return response
}
